import axios from 'axios'
import { ShipmentCreateRequest, ShipmentResponse } from '@/modules/shipments-module/services/shipments.dto'

class ShipmentsCreatorService {
    // Create a shipment to send various shipment requests from a laboratory
    async create(
        originLaboratoryId: number,
        request: ShipmentCreateRequest
    ): Promise<ShipmentResponse> {
        const response = await axios.post<ShipmentResponse>(
            `/shipments/laboratories/${originLaboratoryId}/shipments`,
            request)
        return response.data
    }
}

export const shipmentsCreatorService = new ShipmentsCreatorService()
